import { ProductCategory } from "../constants/products";

export const productCategoryLabelFormatter = (category: ProductCategory, initialLetterCapital?: boolean): string => {
    let label = "";
    switch (category) {
        case ProductCategory.DEVICES:
            label = "seadmed ja tehnika"
            break
        case ProductCategory.TOOLS:
            label = "tööriistad"
            break
        case ProductCategory.HOME:
            label = "kodu"
            break
        case ProductCategory.REALESTATE:
            label = "kinnisvara"
            break
        case ProductCategory.TRANSPORTATION:
            label = "tööriistad"
            break
        case ProductCategory.LEISURE:
            label = "vaba aeg"
            break
        case ProductCategory.SERVICES:
            label = "teenused"
            break
    }
    if (!!initialLetterCapital) {
        label = label.charAt(0).toUpperCase() + label.slice(1);
    }

    return label;
}